<template>
  <!-- Wrapper kept as the single root element so the v-if can guard the modal
       overlay without tripping vue/no-root-v-if. -->
  <div class="pdp-tpl-lightbox-portal">
    <div
      v-if="visible"
      class="pdp-tpl-lightbox"
      @click.self="$emit('close')"
    >
      <div class="pdp-tpl-lightbox__inner">
        <button
          ref="closeBtn"
          type="button"
          class="pdp-tpl-lightbox__close"
          aria-label="Close"
          @click="$emit('close')"
        >
          <i class="bi bi-x-lg" />
        </button>
        <img
          :src="template.thumbnail"
          :alt="template.name"
          class="pdp-tpl-lightbox__img"
        >
        <div class="pdp-tpl-lightbox__actions">
          <button
            v-if="!isSelected"
            type="button"
            class="btn btn-sm btn-primary"
            @click="$emit('select-template', template)"
          >
            Add to selection
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="$emit('deselect-template', template)"
          >
            Remove from selection
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetPdpTemplateLightbox',
  props: {
    visible: { type: Boolean, default: false },
    template: { type: Object, default: () => ({}) },
    isSelected: { type: Boolean, default: false },
  },
  watch: {
    visible(isOpen) {
      if (isOpen) {
        this.previousFocus = (typeof document !== 'undefined') ? document.activeElement : null;
        document.addEventListener('keydown', this.onKeydown);
        // Defer focus until the modal is in the DOM
        this.$nextTick(() => {
          const btn = this.$refs.closeBtn;
          if (btn && typeof btn.focus === 'function') btn.focus();
        });
      } else {
        document.removeEventListener('keydown', this.onKeydown);
        if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
          this.previousFocus.focus();
        }
      }
    },
  },
  created() {
    // Non-reactive instance variable: holds element to restore focus to on close.
    this.previousFocus = null;
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(e) {
      if (e.key === 'Escape') this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.pdp-tpl-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.78);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.pdp-tpl-lightbox__inner {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  max-width: 80vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.pdp-tpl-lightbox__close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  font-size: 18px;
  color: #475569;
  cursor: pointer;
}
.pdp-tpl-lightbox__img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 6px;
}
.pdp-tpl-lightbox__actions {
  display: flex;
  gap: 8px;
}
</style>
